import { render, staticRenderFns } from "./widget-task.vue?vue&type=template&id=737de13d&"
import script from "./widget-task.vue?vue&type=script&lang=js&"
export * from "./widget-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports